import ReactOnRails from "react-on-rails";
import "./application.css";

import HeadAdmins from "../settings/head_admins/HeadAdmins";
import Clients from "../clients/Clients";
import NewCourse from "../courses/NewCourse";
import EditCourse from "../courses/EditCourse";
import Courses from "../courses/Courses";
import CourseDocuments from "../courses/CourseDocuments";
import Sections from "../sections/Sections";
import Passswords from "../settings/passwords/Passwords";
import Name from "../settings/name/Name";
import ClientAdminCourses from "../client_admin/courses/Courses";
import ClientCourses from "../client/Courses";
import ClientCourse from "../client/Course";
import ClientCompletedCourse from "../client/CompletedCourse";
import Users from "../client_admin/users_management/Users";
import Groups from "../client_admin/groups/Groups";

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  HeadAdmins,
  Clients,
  Courses,
  NewCourse,
  EditCourse,
  CourseDocuments,
  Sections,
  Passswords,
  Name,
  ClientAdminCourses,
  Users,
  Groups,
  ClientCourses,
  ClientCourse,
  ClientCompletedCourse,
});
